export default __webpack_public_path__ + "static/media/Calendar_Light_Dark_Modes.3fedc887.png";